export default "__VITE_ASSET__CnsRpStE__"